module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_roundedHover-6ffa123a873a922f460943f51d8405a1.jpg";